import gql from 'graphql-tag';
// # Organization Engagement Report - Overview (panel w/ table containing a row per school)
const GET_ORGANIZATION_ENGAGEMENT_OVERVIEW_REPORT = gql`
  query getOrganizationEngagmentOverviewReport(
    $organizationId: Int!
    $licenseUsageWhere: LicenseUsageWhereInput
  ) {
    prmOrganizationEngagementOverviewReport(where: { organizationId: $organizationId }) {
      organizationOverviews {
        organization {
          id
          name
          licenseUsage(where: $licenseUsageWhere) {
            # Filtering licenseUsage by product.family.code and type will get the 'Sets Licensed' value
            assignedCount
            product {
              code
              type
              family {
                code
              }
            }
            productCurriculum {
              id
              name
            }
          }
        }
        activeStudentCount
        totalStudentCount
        averageLessonTimeSpentSeconds
        overallProgressPercentage
      }
    }
  }
`;

export default GET_ORGANIZATION_ENGAGEMENT_OVERVIEW_REPORT;
